import React from "react";
import { VodTempPlayer } from "./components";
const VodTempPlayerContainer = React.memo(({ playerUrl, renderBottomBtn }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(VodTempPlayer, { playerUrl: playerUrl }),
        renderBottomBtn));
});
export default VodTempPlayerContainer;
